<template>
  <div id="sys-wrapper" @keydown.stop>
    <!--begin --- header ---begin  -->
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-text"><span class="title-tip"></span>新增系统账号</span>
      </div>
      <div class="h-button-warpper">
        <el-button size="small" @click="save" type="primary">保存</el-button>
        <el-button size="small" @click="back" type="primary">返回</el-button>
      </div>
    </div>
    <!--end --- header ---end  -->
    <!--begin --- content ---begin  -->
    <div class="sys-content">
      <el-card class="box-card"  v-for="(ruleForm, index) in ruleForms" :key="index">
        <el-form :model="ruleForm" :rules="rules" :ref="'ruleForm-'+ index"
                 label-position="right" label-width="80px" class="demo-ruleForm" size="mini">
          <el-form-item label="系统" prop="wwSys">
            <el-select v-model="ruleForm.wwSys">
              <el-option v-for="(item,index) in sysList" :label="item.label" :value="item.value" :key="index">
                {{item.label}}
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="账号" prop="wwSysAccount">
            <el-input v-model="ruleForm.wwSysAccount" placeholder="请输入账号，6-20个字符"></el-input>
          </el-form-item>

          <el-form-item label="其他信息" prop="wwOtherInfo">
            <el-input v-model="ruleForm.wwOtherInfo" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="wwSysAccountPassword">
            <el-input v-model="ruleForm.name" placeholder="请输入密码，6-20个字符"></el-input>
          </el-form-item>

          <el-form-item label="下载网址" prop="wwSysDownLoadUrl">
            <el-input v-model="ruleForm.wwSysDownLoadUrl" placeholder="请输入下载网址"></el-input>
          </el-form-item>

          <el-form-item label="账号说明" prop="wwSysAccountDescription">
            <el-input v-model="ruleForm.wwSysAccountDescription" placeholder="请输入"></el-input>
          </el-form-item>

          <el-form-item label="是否启用" prop="wwSysIsUsed">
            <el-radio-group v-model="ruleForm.wwSysIsUsed">
              <el-radio v-for=" (item,index) in isUsedList" :key="index" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="销售数据" prop="wwSysSellerData">
            <el-radio-group v-model="ruleForm.wwSysSellerData">
              <el-radio v-for=" (item, index) in isUsedList" :key="index" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="库存数据" prop="wwSysStockData">
            <el-radio-group v-model="ruleForm.wwSysStockData">
              <el-radio v-for=" (item,index) in isUsedList" :key="index" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="订单数据" prop="wwSysOrderData">
            <el-radio-group v-model="ruleForm.wwSysOrderData">
              <el-radio v-for=" (item,index) in isUsedList" :key="index" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="备注" prop="wwNote">
            <el-input v-model="ruleForm.wwNote" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="sys-footer">
        <el-button size="small" @click="add" type="primary">新增</el-button>
      </div>
    </div>

  </div>

</template>

<script>
  import { mapGetters } from 'vuex'
  import commonMixin from '@/mixins/common.js'

  export default {
    name: 'add',
    mixins: [commonMixin],
    data() {
      const data = {
        wwSys: '', // 系统
        wwSysAccount: '', // 系统账号
        wwSysAccountDescription: '', // 系统账号说明
        wwSysAccountPassword: '', // 密码
        wwSysDownLoadUrl: '', // 下载网址
        wwSysIsUsed: false, // 是否启用
        wwSysSellerData: [], // 是否启用 销售数据
        wwSysStockData: '', // 是否启用 库存数据
        wwSysOrderData: '', // 是否启用 订单数据
        wwNote: '', // 备注
        wwOtherInfo: '' // 其他信息
      }
      return {
        sysList: [
          { label: 'xxx系统', value: '111' }
        ],
        isUsedList: [
          { label: 'y', value: true },
          { label: 'n', value: false }
        ],
        ruleForms: [data],
        tmpData: data,
        rules: {
          wwSys: [ // 系统
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          wwSysAccount: [ // 账号
            { required: true, message: '此项为必填项', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
          ],
          wwSysAccountPassword: [
            { required: true, message: '此项为必填项', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
          ],
          wwSysDownLoadUrl: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          wwSysIsUsed: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          wwSysSellerData: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          wwSysStockData: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          wwSysOrderData: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          wwNote: [
            { required: false, message: '备注', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      back(isRefresh) {
        const path = '/config/%2Ftemplate%2Fmodule%2Fcustomer%2Fcustomer_page_config.json'
        this.goBack(path)
        if (isRefresh) {
          this.$nextTick(() => {
            this.$bus.$emit('refresh-grid')
          })
        }
      },
      save() {
      },
      add() {
        this.ruleForms.push(Object.assign({}, this.tmpData));
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!')
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ])
    },
    mounted() {
    },
    created() {
    }
  }
</script>

<style lang="scss">
  #sys-wrapper {
    position: relative;
    .sys-content {
      margin-top: 20px;
      margin-left: 20px;
      padding-bottom: 20px;
      .el-form-item__label {
        padding-right: 5px !important;
      }

      .el-form-item__error{
        left: 105%;
        width: 200px;
        top: 25%;
      }
      .el-form-item{
        margin-bottom: 10px;
      }

    }
    .sys-footer{
      position: absolute;
      bottom: 0px;
      left: 0px;
      margin-left: 20px;
      height: 60px;
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/systemAccount/add.vue